export default __webpack_public_path__ + "static/media/certificate-icon.c2960199.svg";